import { render, staticRenderFns } from "./BlondFirstOpen.vue?vue&type=template&id=10706d12&"
import script from "./BlondFirstOpen.vue?vue&type=script&lang=ts&"
export * from "./BlondFirstOpen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports